const lgStyles = `
@font-face { font-family: 'Barlow'; font-style: normal; font-weight: 400; font-display: swap; src: url('/fonts/Barlow-Regular.woff2') format('woff2'); }
@font-face { font-family: 'Barlow'; font-style: normal; font-weight: 500; font-display: swap; src: url('/fonts/Barlow-Medium.woff2') format('woff2'); }
@font-face { font-family: 'Barlow'; font-style: normal; font-weight: 600; font-display: swap; src: url('/fonts/Barlow-SemiBold.woff2') format('woff2'); }
@font-face { font-family: 'Barlow Condensed'; font-style: normal; font-weight: 400; font-display: swap; src: url('/fonts/BarlowCondensed-Regular.woff2') format('woff2'); }
@font-face { font-family: 'Barlow Condensed'; font-style: normal; font-weight: 600; font-display: swap; src: url('/fonts/BarlowCondensed-SemiBold.woff2') format('woff2'); }
@font-face { font-family: 'Barlow Condensed'; font-style: normal; font-weight: 700; font-display: swap; src: url('/fonts/BarlowCondensed-Bold.woff2') format('woff2'); }
.lg * { margin:0; padding:0; box-sizing:border-box; }
.lg { min-height:100vh; background:#f5f4f2; font-family:'Barlow',sans-serif; color:#1a1a2e; display:flex; flex-direction:column; align-items:center; padding:22px 18px 60px; }
.lg-top { width:100%; max-width:640px; display:flex; align-items:center; justify-content:space-between; margin-bottom:18px; }
.lg-back { background:none; border:none; font-family:'Barlow Condensed',sans-serif; font-size:14px; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:#999; cursor:pointer; padding:6px 4px; }
.lg-back:hover { color:#e7589b; }
.lg-title { font-family:'Barlow Condensed',sans-serif; font-weight:700; font-size:clamp(28px,7vw,40px); letter-spacing:2px; text-transform:uppercase; color:#e7589b; line-height:1; margin-bottom:4px; text-align:center; }
.lg-updated { font-family:'Barlow Condensed',sans-serif; font-size:12px; font-weight:600; letter-spacing:2px; text-transform:uppercase; color:#bbb; text-align:center; margin-bottom:26px; }
.lg-body { width:100%; max-width:640px; }
.lg-h { font-family:'Barlow Condensed',sans-serif; font-weight:700; font-size:18px; letter-spacing:1px; text-transform:uppercase; color:#1a1a2e; margin:24px 0 8px; }
.lg-body p { font-size:15px; line-height:1.6; margin-bottom:12px; color:#444; }
.lg-body a { color:#e7589b; }
.lg-foot { width:100%; max-width:640px; margin-top:28px; text-align:center; }
.lg-btn { padding:11px 30px; font-family:'Barlow Condensed',sans-serif; font-size:15px; font-weight:700; letter-spacing:2px; text-transform:uppercase; background:#fff; color:#666; border:1.5px solid #ddd; border-radius:8px; cursor:pointer; }
.lg-btn:hover { background:#f5f5f5; color:#333; }
`;

export default function Legal({ onExit }) {
  return (
    <>
      <style>{lgStyles}</style>
      <div className="lg">
        <div className="lg-top">
          <button className="lg-back" onClick={onExit}>← Home</button>
        </div>
        <div className="lg-title">Privacy &amp; Disclaimer</div>
        <div className="lg-updated">Last updated: July 23, 2026</div>

        <div className="lg-body">
          <div className="lg-h">Parody &amp; Fair Use</div>
          <p>
            Buttfumbles is a parody and commentary project inspired by the fictional rosters of the 1990s baseball
            video game <i>Fighting Baseball</i>. The names it generates are produced algorithmically by altering
            source names, and are fictional; any resemblance to a real, living person is coincidental.
          </p>
          <p>
            Buttfumbles is not affiliated with, sponsored by, or endorsed by Major League Baseball, the MLB Players
            Association, the NHL, NFL, NBA, the NCAA, Electronic Arts, Nintendo, Sleeper, or any league, team, player,
            or organization.
            Real athlete names that appear in the game are used for purposes of commentary, criticism, and parody.
            If you believe your name or likeness is being used improperly, please reach out at the contact below and
            we will address it.
          </p>

          <div className="lg-h">Team Logos &amp; Marks</div>
          <p>
            One of the games on this site (&quot;The Protocol&quot;) displays professional and college sports team
            logos. Those logos and team names are the trademarks and property of their respective teams, leagues, and
            organizations. They are shown here for the purposes of identification, commentary, criticism, and parody
            as part of an interactive game about recognizing them &mdash; not to suggest any affiliation with,
            sponsorship by, or endorsement by any team, league, or organization, and Buttfumbles claims no ownership
            of them.
          </p>
          <p>
            If you are the rights holder of a logo or mark shown here and would like it changed or removed, please
            contact us below and we will address it.
          </p>

          <div className="lg-h">The Fantasy Board</div>
          <p>
            The board displays fantasy league information retrieved from Sleeper&apos;s free, publicly documented,
            read-only API. Buttfumbles is an independent project and is not affiliated with, sponsored by, endorsed
            by, or in any way officially connected to Sleeper. &quot;Sleeper&quot; and related marks belong to their
            respective owner.
          </p>
          <p>
            Access is read-only. Buttfumbles never asks for your Sleeper password, never logs in as you, and cannot
            post, edit, trade, set lineups, or change anything in your league. It only reads information Sleeper
            already makes publicly available for a league — team names, avatars, records, matchups, and scores.
          </p>
          <p>
            To display a board we retrieve that public league data and cache it briefly on our server so that many
            viewers of the same board result in a single request to Sleeper rather than one per viewer. Cached data is
            transient, is used only to render the board, and is not sold or shared. If you enter a Sleeper username to
            find your leagues, it is used to perform that lookup and is not stored on our servers; the league you pick
            is remembered in your own browser so the board reopens where you left it, and clearing your browser data
            removes it.
          </p>
          <p>
            Because the data comes from a third party, Buttfumbles cannot guarantee it is accurate, complete, current,
            or available. Scores refresh on a slow cycle and are not official. Do not rely on the board for settling
            league results, wagers, or anything else that matters — check Sleeper directly. The board is provided
            &quot;as is,&quot; without warranties of any kind, and is offered for entertainment only.
          </p>
          <p>
            If you are the rights holder of any data or mark shown here and would like something changed or removed,
            contact us below and we will address it.
          </p>

          <div className="lg-h">Privacy</div>
          <p>
            Buttfumbles does not ask you to create an account and does not collect names, emails, or other personal
            information. Anything you type into the name generator stays in your browser and is never sent to a
            server. The board is the one exception, and only because it has to be: a Sleeper username or league ID is
            sent to our server to look up that league&apos;s public data, as described above.
          </p>
          <p>
            The site is hosted on Vercel, which, like most web hosts, may automatically log standard technical
            information (such as IP addresses, browser type, and requested pages) for security, performance, and
            operational purposes. We do not use this information to identify you and do not sell it.
          </p>
          <p>
            Buttfumbles does not run advertising and does not use advertising or tracking cookies. If we add analytics
            or any third-party services in the future, this page will be updated to describe them.
          </p>

          <div className="lg-h">Contact</div>
          <p>
            Questions, requests, or takedown concerns: <a href="mailto:playspancakes@gmail.com">playspancakes@gmail.com</a>.
          </p>
        </div>

        <div className="lg-foot">
          <button className="lg-btn" onClick={onExit}>Back to Home</button>
        </div>
      </div>
    </>
  );
}
